import { render, staticRenderFns } from "./KeyBoxEdit.vue?vue&type=template&id=04b95aad&scoped=true&"
import script from "./KeyBoxEdit.vue?vue&type=script&lang=js&"
export * from "./KeyBoxEdit.vue?vue&type=script&lang=js&"
import style0 from "./KeyBoxEdit.vue?vue&type=style&index=0&id=04b95aad&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04b95aad",
  null
  
)

export default component.exports